module.exports = __webpack_public_path__ + "static/arrow_left-f6b4682267a00746c3828765b5e28145.png";